import { Component, ElementRef, Input, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-radio',
    template: `
        <div
            style="--colGap:{{ colGap }};--paddingTop:{{ paddingTop }};--flexDirection:{{flexDirection}};--scale:{{scale}}"
            class="form-group"
        >
            <label>{{ label }}</label>
            <div class="radio-options">
                <label *ngFor="let option of options">
                    <span class="item-radio input-radio">
                        <span class="input-radio__body">
                            <input
                                #input
                                class="input-radio__input"
                                [formControl]="control"
                                name="{{ label }}"
                                [value]="option.key"
                                type="radio"
                            />
                            <span
                                class="input-radio__circle input-radio-primary"
                            ></span>
                        </span>
                    </span>
                    <span class="item-title">{{ option.value }}</span>
                </label>
            </div>
        </div>
    `,
    styles: [
        ` .input-radio__body {
            scale: var(--scale) !important;
          }
            .radio-options {
                display: flex;
                column-gap: var(--colGap);
                padding-top: var(--paddingTop);
                flex-direction: var(--flexDirection);

                .item-title {
                    position: relative;
                    bottom: 1px;
                    left: 10px;
                    font-size: 14px !important;
                }
            }
        `,
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: RadioComponent,
            multi: true,
        },
    ],
})
export class RadioComponent implements OnInit {
    @Input() control = new FormControl();
    @Input() label: string;
    @Input() options: any[] = [];
    @Input() colGap: string = '3rem';
    @Input() paddingTop: string = '17px';
    @Input() flexDirection: 'row' | 'column' = 'row';
    @Input() scale: any = 1;

    private onChange!: Function;
    private onTouched!: Function;
    disabled: boolean;

    @ViewChildren('input') inputElementsRef: QueryList<ElementRef>;


    constructor(private _renderer: Renderer2) {

    }

    ngOnInit(): void {
        this.control.valueChanges.subscribe((res) => {
            this.onChange(this.control.value);
        });
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        // if (value) {
            this.control.setValue(value, { emitEvent: false });
        // }
    }

    setDisabledState(isDisabled: boolean): void {
        this.inputElementsRef.forEach(inputElementRef => {
            this._renderer.setProperty(inputElementRef.nativeElement, 'disabled', isDisabled);
        })
        this.disabled = isDisabled;
    }
}
